var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wms-resource",rawName:"v-wms-resource:text",value:('info'),expression:"'info'",arg:"text"}],staticClass:"info-resource"})}
var staticRenderFns = []

export { render, staticRenderFns }